import { useAccount } from '../../lib/account/useAccount';
import { useSwitchAccount } from '../../hooks/useSwitchAccount';
import { administeredKindTitle } from '../../lib/practice-settings';
import { InfoIcon } from '../ui/InfoIcon';
import { Button } from '../ui/Button';

/**
 * Persistent shell bar shown while viewing an administered entity
 * (a company in business rescue, an insolvency, a deceased estate).
 * Hidden on an ordinary firm account - `account.administeredBy` is null there.
 */
export function AdministeredEntityBanner() {
  const { account } = useAccount();
  const switchAccount = useSwitchAccount();

  const administeredBy = account?.administeredBy;

  if (!administeredBy || !account) return null;

  const kindTitle = administeredKindTitle(account.practiceSettings?.practiceType ?? null);
  const bannerText = kindTitle
    ? `${account.name} · ${kindTitle} · administered by ${administeredBy.accountName}`
    : `${account.name} · administered by ${administeredBy.accountName}`;

  return (
    <div className="border-b border-primary/15 bg-bg-warm px-4 py-3 sm:px-6">
      <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
        <div className="flex items-start gap-2.5">
          <InfoIcon className="mt-0.5 h-4 w-4 flex-shrink-0 stroke-primary" />
          <p className="text-sm text-secondary">
            {bannerText}
          </p>
        </div>
        <Button
          variant="secondary"
          size="sm"
          className="flex-shrink-0"
          loading={switchAccount.isPending}
          onClick={() =>
            switchAccount.mutate({
              accountId: administeredBy.accountId,
              to: `/clients/${administeredBy.clientId}`,
            })
          }
        >
          Back to {administeredBy.accountName}
        </Button>
      </div>
    </div>
  );
}
